export interface Bonus {
  id: string
  title: string
  subtitle: string
  intro?: string
  bulletsIntro?: string
  bullets?: string[]
  secondaryBulletsIntro?: string
  secondaryBullets?: string[]
  systemLabel?: string
  system?: string
  closing?: string[]
}

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: 'Scuba Instructor Cueing & Error Correction Handbook',
    subtitle: 'See the mistake. Understand the cause. Give the right correction.',
    intro:
      'A practical instructor reference designed to help you recognize student problems and respond with clearer teaching cues.',
    systemLabel: 'Core framework:',
    system: 'ERROR → CAUSE → CUE → CORRECTION → RETRY',
    closing: ['Stop simply saying: “Try again.”', 'Start giving the student a clearer correction.'],
  },
  {
    id: '2',
    title: '100 Scuba Training Drills, Skill Challenges & Student Practice Tasks',
    subtitle: 'Never run out of structured practice activities.',
    bulletsIntro: 'Includes ready-to-use activities for:',
    bullets: [
      'Buoyancy',
      'Trim',
      'Hovering',
      'Breathing awareness',
      'Mask skills',
      'Regulator skills',
      'Finning',
      'Navigation',
      'Buddy positioning',
      'Communication',
      'Underwater control',
      'Task integration',
      'Confidence',
      'Precision',
    ],
    closing: [
      'Use them whenever a student needs more practice without creating another drill yourself.',
    ],
  },
  {
    id: '3',
    title: 'Scuba Student Assessment & Progress Tracking System',
    subtitle: 'Know where your student is — and what they should work on next.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Skill assessments',
      'Student records',
      'Progress checklists',
      'Visual rubrics',
      'Lesson tracking',
      'Recurring-error tracking',
      'Instructor observations',
      'Readiness indicators',
      'Next-session objectives',
      'Progress summaries',
    ],
    closing: ['Stop guessing whether the student is progressing.', 'Track it.'],
  },
  {
    id: '4',
    title: 'Scuba Lesson Planning & Skill Progression System',
    subtitle: 'Build better lesson progression without starting from zero.',
    bulletsIntro: 'Includes:',
    bullets: [
      'Ready-made lesson structures',
      'Beginner pathways',
      'Developing-diver pathways',
      'Skill sequencing',
      'Lesson progression maps',
      'Student-specific planning',
      'Simplify / repeat / progress frameworks',
      'What-to-teach-next tools',
    ],
    systemLabel: 'Core flow:',
    system: 'ASSESS → CHOOSE → TEACH → PRACTICE → CHECK → PROGRESS',
  },
  {
    id: '5',
    title: 'Scuba Training Troubleshooting & Problem-Solving Manual',
    subtitle: 'See the problem. Find the cause. Apply the fix.',
    bulletsIntro: 'A practical diagnostic resource for situations such as:',
    bullets: [
      'Poor buoyancy',
      'Unstable trim',
      'Repeated depth changes',
      'Excessive fin movement',
      'Hand sculling',
      'Mask anxiety',
      'Regulator discomfort',
      'Loss of control during skills',
      'Poor buddy awareness',
      'Navigation overload',
      'Student anxiety',
      'Task saturation',
    ],
    systemLabel: 'Core framework:',
    system: 'PROBLEM → ROOT CAUSE → SIMPLIFY → CORRECT → RETRY → RECHECK',
  },
]
